// =====================================
//	退款記錄 modal
//
//	@author: Gray
//	@time 2017 / 08 / 21
// =====================================

window.InifECMobileApp.directive('orderRefundLogList', ['$rootScope', '$ngModal', '$timeout',
	function ($rootScope, $ngModal, $timeout) {

		var _dir = {};

		var controller = ['$scope', function($scope) {

            var cancel = function() {

                closeModal();
            }

            // -------------------------------
            // [private] 開啟 modal
            // -------------------------------
            var openModal = function() {

            	$ngModal.openModal('order-refund-log-list');
            }

            // -------------------------------
            // [private] 關閉 modal
            // -------------------------------
            var closeModal = function() {

            	$ngModal.closeModal('order-refund-log-list');
            }

            /*==========================
                Events
            ==========================*/            
            $scope.$on('OPEN_ORDER_REFUND_LOG_LIST_MODAL', function(event, data) {
                $scope.refundInfos = [];
                if(data) {
                    $scope.refundInfos = data.refundInfos;
                    openModal();
                }
            });

            /*==========================
                Members
            ==========================*/
            $scope.refundInfos = [];
            
            /*==========================
                Methods
            ==========================*/
            $scope.cancel = cancel;

            /*==========================
                init
            ==========================*/

		}]

		_dir.restrict = "E";
		_dir.scope = true;
		_dir.templateUrl = "mobile/partials/modal/order_refund_log_list.html";
		_dir.controller = controller;

		return _dir;
	}]
);